import { render, staticRenderFns } from "./VirtualMachines.vue?vue&type=template&id=0a4be5a3&"
import script from "./VirtualMachines.vue?vue&type=script&lang=js&"
export * from "./VirtualMachines.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports